import { boot } from 'quasar/wrappers'
import { installScreenBreakpointSync } from 'booksprout-app/src/screen/breakpoints'

/**
 * Our breakpoints are rem based (see the `from()`/`to()` sass mixins) but Quasar's `$q.screen`
 * compares pixels, so the two disagree for anyone whose browser font size isn't 16px. Teach
 * Quasar the rem thresholds before the first render [sc-27864].
 *
 * Client only: there is no root font size — or viewport — to read on the server.
 */
export default boot(() => {
  installScreenBreakpointSync()
})
